export default import.meta.ROLLDOWN_FILE_URL_K0d7Xv_kmrg9pjrMnixeoA